import { combineReducers } from 'redux';
import { sendTaskModalReducer } from '../Modals/SendTask/store/SendTaskModalReducer';
import { bookingReducer } from '../Modals/BookingModal/store/booking.reducer';

export const modalsReducer = combineReducers({
  sendTaskModal: sendTaskModalReducer,
  bookingModal: bookingReducer,
});
